import { render, staticRenderFns } from "./EstudianteEvaluacionesPendientes.vue?vue&type=template&id=5dad719f&scoped=true"
import script from "./EstudianteEvaluacionesPendientes.vue?vue&type=script&lang=js"
export * from "./EstudianteEvaluacionesPendientes.vue?vue&type=script&lang=js"
import style0 from "./EstudianteEvaluacionesPendientes.vue?vue&type=style&index=0&id=5dad719f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad719f",
  null
  
)

export default component.exports